import { BinderConfigurator, ComponentTagMappings, SamePropertyNamesBinder, ViewGenerator } from "binder";
import momentNamepsace from "moment";
import { MainWindowView } from "./common/mainWindow/mainWindow-view";
import { MainWindowViewModel } from "./common/mainWindow/mainWindow-viewModel";
import { Converters } from "./converters";
import { TranslatorConverter } from "./TranslatorConverter";
import { MediaSelector } from "./uicomponents/components/mediaSelector";
declare var moment;
declare var persianDate:any;
window.onload = function(){
    if(screen.width > 800) {
        persianDate.toLeapYearMode('astronomical');
        var vp = document.querySelector('meta[name="viewport"]');
        vp.setAttribute('content','width=device-width, initial-scale=0.8');
    }
    
    require('uicomponents');
    moment = momentNamepsace;
    new BinderConfigurator().pushConverterRepository(new Converters());
    new BinderConfigurator().pushConverterRepository(new TranslatorConverter());
    let viewModel = new MainWindowViewModel(null);
    const mainPageDiv = document.getElementById('mainPageDiv');
    function render(media?){
        
        console.log(media?.media)
        let view = viewModel.GetDefaultView();
        view.dataContext = viewModel;
        SamePropertyNamesBinder.bindSourceAndDestination(viewModel,view);
        let html = ViewGenerator.GetHtml(view);
        mainPageDiv.replaceChildren(html)
        view.onRenderCompleted();
    }
    let mediaSelector = new MediaSelector();
    mediaSelector.addListenner(x=>render(x));
    render();
}

